export const BillingTabGateAccessRequired = [
  "aucp_SubscriptionLicenceListCompanyActive",
  "aucp_MasterInvoicePdf",
  "aucp_MasterInvoiceData",
  "aucp_MasterInvoiceList",
  "aucp_MasterPaymentCardDelete",
  "aucp_MasterPaymentCardUpdate",
  "aucp_MasterPaymentCardCompanyCreate",
  "aucp_MasterPaymentCardRead",
  "aucp_MasterPaymentCardCompanyList",
  "aucp_SubscriptionLicenceUpdateCompany",
  "aucp_SubscriptionLicenceCreateCompany",
  "aucp_SubscriptionLicenceListCompany",
  "aucp_SubscriptionProductList",
  "aucp_CompanyToUserListTeam",
];
